<template>
  <div>
    <el-upload
      v-if="type === 'button'"
      :class="`uploader button `+(!showBtn?`full`:``)"
      :action="addressOss"
      :before-upload="upload"
      :data="dataOss"
      :file-list="list"
      :limit="limit"
      :accept="accept"
      :on-success="uploadSuccess"
      :on-error="uploadError"
      :on-remove="uploadRemove"
    >
      <el-button
        size="small"
        slot="trigger"
        type="primary"
        :disabled="!showBtn"
        >{{ placeholder }}</el-button
      >
      <slot name="append" v-if="$slots.append">
        <span></span>
      </slot>
    </el-upload>
    <el-upload
      v-if="type === 'input'"
      class="uploader input"
      :action="addressOss"
      :before-upload="upload"
      :data="dataOss"
      :file-list="list"
      :limit="limit"
      :accept="accept"
      :on-success="uploadSuccess"
      :on-error="uploadError"
      :on-remove="uploadRemove"
    >
      <el-input
        type="text"
        class="picker"
        :placeholder="showBtn ? placeholder : ''"
        slot="trigger"
        readonly
        :disabled="!showBtn"
      >
        <i slot="prefix" :class="`el-input__icon ` + icon"></i>
        <i
          slot="suffix"
          class="el-input__icon el-icon-folder-opened"
          v-if="showBtn"
        ></i>
      </el-input>
      <slot name="append" v-if="$slots.append">
        <span></span>
      </slot>
    </el-upload>
    <el-upload
      v-if="type === 'picture'"
      list-type="picture-card"
      :class="`uploader picture ` + (showBtn ? '' : 'full ') + (uploading?'uploading':'')"
      :action="addressOss"
      :before-upload="upload"
      :data="dataOss"
      :file-list="list"
      :limit="limit"
      accept="image/*"
      :on-success="uploadSuccess"
      :on-error="uploadError"
      :on-remove="uploadRemove"
    >
      <i class="el-icon-plus"><br/><span class="placeholder">{{placeholder}}</span></i>
      
    </el-upload>
  </div>
</template>
<script>
import { aliOss } from "@/api/main.js";
export default {
  name: "uploader",
  props: {
    placeholder: {
      type: String,
      default: "上传文件",
    },
    type: {
      type: String,
      default: "button",
    },
    accept: {
      type: String,
      default: "",
    },
    limit: {
      type: Number,
      default: 1,
    },
    className: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "el-icon-document",
    },
    beforeUpload:{
      type:Function,
      default:()=>{return true}
    },
    fileList: {
      type: Array,
      default() {
        return [];
      },
    },
    
  },
  data() {
    return {
      dataOss: {},
      addressOss: "",
      host: "",
      filePath: "",
      uploading:false,
      list: [],
    };
  },
  watch: {
    fileList(val) {
      this.list = val;
    },
  },
  created() {
    this.list = this.fileList;
  },
  computed: {
    showBtn() {
      return this.list.length < this.limit;
    },
  },
  methods: {
    async upload(file) {
      let before = true;
      if (this.beforeUpload) {
        before = this.beforeUpload(file)
      }
      if(!before) {
        return Promise.reject("upload error")
      }
      else {
        this.uploading = true;
        let d = await aliOss({ filename: file.name });
        this.addressOss = d.data.url; //上传地址
        (this.host = d.data.host),
          // 对象名由服务端按文件类型白名单生成，客户端必须原样使用
          (this.filePath = d.data.key),
          (this.dataOss = {
            key: this.filePath,
            ossAccessKeyId: d.data.accessid,
            policy: d.data.policy,
            signature: d.data.signature,
            success_action_status: "200",
            // file:file
          }); //上传额外参数
      }
    },
    uploadError(err, file, fileList) {
      this.uploading = false;
      this.$message.error("上传失败！");
      this.$emit("on-error", { err, file, fileList });
      this.$emit("change", fileList);
      this.dispatch('ElFormItem', 'el.form.change', [this.list]);
      this.list = fileList;
    },
    uploadSuccess(err, file, fileList) {
      this.uploading = false;
      this.$message.success("上传成功！");
      file.filePath = this.filePath;
      this.$emit("on-success", { fileList });
      this.$emit("change", fileList);
      this.dispatch('ElFormItem', 'el.form.change', [this.list]);
      this.list = fileList;
    },
    uploadRemove(file, fileList) {
      this.$emit("on-success", { fileList });
      this.$emit("change", fileList);
      this.dispatch('ElFormItem', 'el.form.change', [this.list]);
      this.list = fileList;
    },
    dispatch(componentName, eventName, params) {
      var parent = this.$parent || this.$root;
      var name = parent.$options.componentName;
      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent;
        if (parent) {
        name = parent.$options.componentName;
        }
      }
      if (parent) {
        parent.$emit.apply(parent, [eventName].concat(params));
      }
    },
  },
};
</script>
<style lang="scss">
.uploader {
  .el-input__icon {
    font-size: 20px;
  }
  &.full {
    .el-upload {
      pointer-events: none;
    }
  }
  &.input {
    .el-upload {
      width: 100%;
      .picker {
        &.is-disabled {
          .el-input__inner {
            background-color: #fff;
          }
        }
      }
    }
    .el-upload-list {
      position: absolute;
      top: 1px;
      left: 1px;
      right: 7px;
      border-radius: 5px;
      li {
        margin-top: 0;
        padding-left: 30px;
        height: 34px;
        line-height: 34px;
        a > i {
          display: none;
        }
        > i {
          margin-top: 6px;
        }
        &:hover {
          background-color: transparent;
        }
      }
    }
  }
  &.picture {
    height: 124px;
    overflow: hidden;
    img {
      object-fit:cover
    }
    .el-icon-plus {
      margin-top: 30px;
      font-size: 40px;
      line-height: 30px;
    }
    .placeholder {
      font-size: 14px;
      text-align: center;
    }
    li {
      width: 180px;
      height: 124px;
    }
    .el-upload--picture-card {
      width: 180px;
      height: 124px;
    }
    &.full {
      .el-upload {
        display: none;
      }
    }
    &.uploading {
      .el-upload {
        display: none;
      }
    }
  }
}
</style>